<template>
  <div class="app-team-page">
    <app-nav-page-view :tabHoverPage="2"></app-nav-page-view>
    <div class="app-team-banner">
      <app-banner-view
        :titleImageBackground="appTeamBannerImage"
        :titleObj="teamBannerObj"
      ></app-banner-view>
    </div>
    <div class="management-content">
      <app-title-page-view
        :titleObj="managementTitleObj"
      ></app-title-page-view>
      <app-management-swiper
        v-if="managementList.length"
        :managementList="managementList">
      </app-management-swiper>
    </div>
    <div class="technology-content" v-if="false">
      <app-title-page-view
        :titleObj="technologyTitleObj"
      ></app-title-page-view>
      <app-technology-swiper
        v-if="technologyList.length"
        :technologyList="technologyList">
      </app-technology-swiper>
    </div>
    <app-footer-page></app-footer-page>
  </div>
</template>
<script>
  import AppManagementSwiper from '@/components/app/team/AppManagementSwiper.vue'
  import AppTechnologySwiper from '@/components/app/team/AppTechnologySwiper.vue'
  export default {
    name:'',
    data(){
      return {
        bannerSlidesPerView:3,
        bannerSlidesPerColumn:2,
        appTeamBannerImage: require('./image/app-team-banner-image.png'),
        ceoLiuZong:require('./image/ceo-liuzong.jpg'),
        ceoQianZong:require('./image/ceo-qianzong.jpg'),
        zjBuHao:require('./image/zj-buhao.jpg'),
        teamBannerObj:{
          mainHeading:'团队介绍',
          subhead:'力致打造行业领导者',
          content:'Shanghai golden guarantee network technology co. LTD'
        },
        teamTitleObj:{
          mainHeading:'',
          subhead:'管理团队',
          content:''
        },
        managementTitleObj:{
          mainHeading:'',
          subhead:'管理团队',
          content:''
        },
        technologyTitleObj:{
          mainHeading:'',
          subhead:'技术团队',
          content:''
        },
        technologyList: [
          // {imgUrl:require('./image/rs-biqiu.jpg'),
          //   content: '来自于成都的川妹子，拥有与生俱来的热情。做人力资源工作多年，' +
          //   '熟悉人力资源的招聘与配置、培训与开发、绩效管理、薪酬福利管理、劳动关系' +
          //   '管理六大模块。现担任本公司人力资源主管。',
          //   manifesto:'个人宣言：感恩之心离财富最近。',
          //   name:'沈碧秋_',
          //   duty:'HR'},
//          {imgUrl:require('./image/cp-yubo.jpg'), content: '4年的互联网产品设计经验，熟悉UCD设计理念，熟悉整个产品设计流程和产品基本设计原则，专注于竞品分析、市场调研和用户研究，熟练运用Axure、Mindmanager、Visio等产品设计软件及Office办公软件。现任本公司产品经理一职负责浦发银行、买单吧、交行手机银行、平安银行、光大银行、北京银行、广发银行、江苏农行、建设银行、农业银行、华夏银行、项目前端设计。', manifesto:'', name:'于渤_', duty:'助理产品经理'},
          {imgUrl:require('./image/hd-xumiao.jpg'), content: '6年Java编程领域的工作经验，熟悉各类主流框架，对分布式、高并发系统架构有着一定的经验积累，熟悉各种主流第三方支付平台和银行支付接入，熟悉Linux系统，有着丰富的实施部署经验。', manifesto:'个人宣言：点点滴滴皆重要，处处学习是诀窍。 ', name:'徐淼_', duty:'JAVA开发主管'},
          {imgUrl:require('./image/hd-jiangli.jpg'), content: '13年毕业至今一直从事Java编程领域的工作，熟练掌握Spring等各大主流框架，对系统架构有着一定的经验积累。曾主导多个系统的建设工作，熟悉Linux系统，有着丰富的实施部署经验。对技术有着热烈的爱好，立志成为一名全栈工程师。个人网站：https://zero502.com', manifesto:'个人宣言：活到老，学到老，努力提升个人价值，为公司创造更大的价值。', name:'蒋立_', duty:'JAVA开发主管'},
          {imgUrl:require('./image/hd-mengjianli.jpg'), content: '多年Java web开发经验，精通JavaEE技术体系，熟悉产品开发流程，逻辑思维严谨，条理清晰，在公司主要负责浦发银行、建设银行、民生银行项目后端项目开发维护与优化。', manifesto:'个人宣言：我们生来就是为了解决世界上90%的人不够懒而来的', name:'孟健立_', duty:'JAVA开发主管'},
          {imgUrl:require('./image/hd-wangbaixing.jpg'), content: '金保证后端开发工程师，负责中国银行、华夏银行项目开发及维护，浦发银行部分功能开发及维护，公司内部管理后台开发及维护等。', manifesto:'个人宣言:  让人非我弱，得志莫离群', name:'王百兴_', duty:'JAVA开发工程师'},
          {imgUrl:require('./image/hd-sunshuangli.jpg'), content: '毕业于西安交通大学计算机系，3年+的Java开发经验，扎实的编程功底，熟悉常用的数据结构和算法,精通Spring，hibernate等常用框架，熟练应用nginx，kafka，redis，mysql等中间件掌握IntelliJ IDEA开发工具，熟悉maven项目配置、熟悉svn、git基本操作，分支管理策略', manifesto:'个人宣言：别人解决不了的问题，交给我。', name:'孙双利_', duty:'JAVA开发工程师'},
          // {imgUrl:require('./image/hd-zhangkai.jpg'), content: ' 熟练使用Spring、Struts、Hibernate三大框架编程，精通SQL语言，具备mvc实践、PO经验和 Oracle、SqlServer 、MySQL 等大型数据库开发经验,现担任本公司平安银行、光大银行项目的后端开发职务。', manifesto:'个人宣言：学习是远离平庸最有效的方法。', name:'张凯_', duty:'JAVA开发工程师'},
          {imgUrl:require('./image/qd-zhangtiefeng.jpg'), content: '资深前端架构师、全栈工程师，涉猎web，APP，机器学习等多个领域，曾参与人脸识别相关业务开发，百万级用户项目开发，ACM获奖者，node.js热衷者，python爱好者，github活跃者。', manifesto:'个人宣言：天行健，君子以自强不息', name:'张铁峰_', duty:'前端开发主管'},
          {imgUrl:require('./image/qd-zhanghaoxuan.jpg'), content: '金保证WEB前端工程师，多年前端工作经验，熟练使用Vue，React等主流开发框架并熟练微信小程序的开发，熟练使用前端主流工具，并且都有完整上线项目。现担任本公司民生银行，广发银行，平安银行等项目的前端开发职务。', manifesto:'个人宣言：落后就要挨打。', name:'张浩轩_', duty:'前端开发工程师'},
          {imgUrl:require('./image/qd-wushiling.jpg'), content: '前端妹子一枚，熟悉 JavaScript/HTML5/CSS3 等相关前端开发技术、精通面向对象的 JavaScript, jQuery, DOM 操作、熟练使用React,Vue 与周边生态进行核心、业务、组件的开发ECMA编程能迅速熟悉新的前端架构，目前负责本公司浦发银行、北京银行、中国银行的前端开发工作', manifesto:'个人宣言：不要等待机会、而要创造机会', name:'吴世玲_', duty:'前端开发工程师'},
          {imgUrl:require('./image/qd-pengdashuai.jpg'), content: '5年互联网前端开发经验，熟练使用photoshop绘图工具，熟练使用Vue，agularjs、React等主流开发框架并熟练PHP及Node（egg框架）开发，熟练使用前端主流工具，熟悉w3c规范。现担任本公司工商银行、建设银行，光大银行、官网及斗票网平台的项目开发工作，并兼任公司网络管理业务，如网络维护、邮箱管理、服务器管理等。', manifesto:'个人宣言：知识是进步的桥梁', name:'彭大帅_', duty:'前端开发工程师'},
          // {imgUrl:require('./image/cs-zhangzhijia.jpg'), content: '金保证软件测试人员，精通常用的测试工具、性能测试。熟悉产品测试流程，逻辑思维严谨，条理清晰，脑洞较大，参与过都多次高并发项目。熟练使用自动化appium selenium，python 框架。', manifesto:'个人宣言：If you’re afraid to fail then you’re probably going to fail', name:'张志佳_', duty:'测试主管'},
          {imgUrl:require('./image/cs-zhaohui.jpg'), content: '金保证软件测试人员，主要负责平安、广发、中国银行和其他合作银行部分测试工作。', manifesto:'个人宣言：学习使人进步', name:'赵慧_', duty:'测试工程师'}
//          {imgUrl:require('./image/ui-wangbin.jpg'), content: '坚持以用户为中心的思想设计，拥有3年平面品牌设计经验、5年+互联网、软件、电商移动端PC端视觉、交互、运营设计经验，\n现负责本公司全局产品美观度、色彩风格、图标、产品气质等品牌形象，形成设计规范', manifesto:'个人宣言：在更新的屏幕里创造出更好的产品和更优的体验。', name:'王斌_', duty:'设计主管'},
//          {imgUrl:require('./image/ui-lizhaolu.jpg'), content: '16年毕业于山东传媒学院艺术系，从小对艺术的热爱，2年的互联网移动端设计经验，精通 WebiOS、Android的设计规范；色彩认知力比较强，配合现有美术把产品设计做得更好，现在负责本公司移动端PC端的设计工作', manifesto:'个人宣言：在生活中追求艺术之美的存在，不断学习进步', name:'李兆鲁_', duty:'产品设计师'}
        ],
        managementList:[
//          {
//            imgUrl:require('./image/ceo-qianzong.jpg'),
//            content: '',
//            manifesto:'',
//            name:'钱景_',
//            duty:'执行副总'},
//           {
//             imgUrl:require('./image/ceo-liuzong.jpg'),
//             content: '拥有十余年的实体企业经营及上市企业管理经验，深谙境内外实业与资本运营相结合运作模式，\n' +
//             '对资本市场发展趋势和金融创新模式有深刻理解。熟悉国家金融业相关政策法规，对上市企业项目融资、\n' +
//             '并购重组、定向增发、资产证券化（ABS）等资本运作具有丰富的经验。善于将先进的企业管理理念融入\n' +
//             '到现代化的金融创新平台中来，熟悉私募股权投融资运作，统筹公司战略发展规划，制订公司年度经营管理计划，\n' +
//             '实施目标分解，运用组织、领导、协调、沟通、监督、检查等管理手段，全面提高公司的组织管理、人力资源管理、\n' +
//             '财务管理、营销管理水平，增强企业的市场竞争力。',
//             manifesto:'',
//             name:'刘裕_',
//             duty:'资深副总'},
//           {
//             imgUrl:require('./image/zj-buhao.jpg'),
//             content: '从事软件开发行业7年，拥有4年架构经验，2年管理经验，擅长敏捷开发，对分布式系统、高并发系统有着深入的理解和实战经验，精通java语言，且熟练掌握js、golang、shell等语言的运用。',
//             manifesto:'个人宣言：只要思想不滑坡，方法总比困难多，一个人牛不算什么，带动整个团队牛才是真的牛。',
//             name:'卜浩_',
//             duty:'技术总监'}
        ]
      }
    },
    components:{
      'app-management-swiper':AppManagementSwiper,
      'app-technology-swiper':AppTechnologySwiper
    },
    computed:{
    },
    methods:{
      actionClickBanner(index){
        console.log(index);
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .app-team-page{
    .app-team-banner{
      width:100%;
    }
    .management-content, .technology-content{
      background:$color-4;
    }
  }
</style>
